import { render, staticRenderFns } from "./TkDatePicker.vue?vue&type=template&id=32a551f3&scoped=true&"
import script from "./TkDatePicker.vue?vue&type=script&lang=js&"
export * from "./TkDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./TkDatePicker.vue?vue&type=style&index=0&id=32a551f3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a551f3",
  null
  
)

export default component.exports